import { Component, Input } from '@angular/core'
import { ResearchService } from '../../../../services/research.service'
import { TranslocoModule } from '@jsverse/transloco'
import { StatisticsService } from '../../../../services/statistics.service'

@Component({
   selector: 'app-more-questions',
   standalone: true,
   imports: [TranslocoModule],
   templateUrl: './more-questions.component.html',
   styles: ''
})
export class MoreQuestionsComponent {

   @Input() questions!: string[]
   @Input() language = 'en'

   constructor(private research: ResearchService, private stats: StatisticsService) { }

   askQuestion(question: string) {
      this.research.setAnswer(question)
      this.stats.search(question, 'more-questions')
   }
}
